import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Form, Offcanvas } from "react-bootstrap";
import Select from "react-select";
import { Controller, useForm } from "react-hook-form";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Gray_Btn from "../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import Success_Toster from "../../../../../common/common_modal/success_toster/Success_Toster";
import Refresh_btn from "../../../../../common/common_btn/refresh_btn/Refresh_btn";

const Add_Role = ({ show, handleClose }) => {
  const onSubmit = async (data) => {
    handleClose();
    setSuccess(true);

     setTimeout(() => {
    setSuccess(false);
    handleClose();
  }, 3000);
  };

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
    setError,
  } = useForm();
  const [showMap, setShowMap] = useState(false);
  const [hideForm, setHideForm] = useState(false);
  const [success, setSuccess] = useState(false);

  const [viewDoc, setViewDoc] = useState(false);

  const countries = [
    { label: "India", value: "1" },
    { label: "USA", value: "2" },
    { label: "UK", value: "3" },
  ];

  const [activeTab, setActiveTab] = useState("basic");

  const documentSectionRef = useRef(null);
  const basiSectionRef = useRef(null);

  const handleTabClick = (tab) => {
    setActiveTab(tab);

    if (tab === "basic" && basiSectionRef.current) {
      basiSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }

    if (tab === "document" && documentSectionRef.current) {
      documentSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };



  return (
    <Offcanvas
      className="mobile_offcanvas common_offcanvas"
      show={show}
      placement="end"
      onHide={handleClose}
      scroll={false}
      backdrop={true}
    >
      <Offcanvas.Header>
        <Offcanvas.Title>
          <div className="back_div" onClick={handleClose}>
            <Common_Back_Btn />
          </div>
          Add New Role
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="add_form">
          <Form onSubmit={handleSubmit(onSubmit)}>
            {/* form 2 */}
            <div className="white_container" ref={documentSectionRef}>
              <div className="common_form_div">
                <div className="row">
                  <div className="col-sm-12">
                    <Form.Group
                      className="form_group"
                      controlId="formBasicName"
                    >
                      <Form.Label>Role Name</Form.Label>
                      <Form.Control type="text" placeholder="eg. LAB MANAGER" />
                      {errors?.credit_price && (
                        <Form.Text className="text-danger">
                          {errors?.credit_price?.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>
                  <div className="col-sm-12">
                    <Form.Group
                      className="form_group"
                      controlId="formBasicName"
                    >
                      <Form.Label>Role Description(Optional)</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Type Description"
                      />
                      {errors?.credit_price && (
                        <Form.Text className="text-danger">
                          {errors?.credit_price?.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-sm-6">
                    <Form.Group
                      className="form_group"
                      controlId="formBasicName"
                    >
                      <Form.Label>Current Status:</Form.Label>
                    </Form.Group>
                  </div>

                  <div className="col-sm-6">
                    <div className="radio_holder">
                      <Form.Check
                        inline
                        type="radio"
                        label="Active"
                        name="sampleType"
                        value="Active"
                        id="Active"
                        className="green_text"
                      />
                      <Form.Check
                        inline
                        type="radio"
                        label="Inactive"
                        name="sampleType"
                        value="Inactive"
                        id="Inactive"
                        className="red_text"
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <Form.Group
                      className="form_group"
                      controlId="formBasicName"
                    >
                      <Form.Label>Created By(Auto Fetch)</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Type Description"
                      />
                      {errors?.credit_price && (
                        <Form.Text className="text-danger">
                          {errors?.credit_price?.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-sm-6">
                    <Form.Group
                      className="form_group"
                      controlId="formBasicName"
                    >
                      <Form.Label>Created Date(Auto Fetch)</Form.Label>
                      <Form.Control
                        type="date"
                        placeholder="Type Description"
                      />
                      {errors?.credit_price && (
                        <Form.Text className="text-danger">
                          {errors?.credit_price?.message}
                        </Form.Text>
                      )}
                    </Form.Group>
                  </div>

                  <div className="col-sm-12">
                    <Form.Group
                      className="form_group"
                      controlId="formBasicName"
                    >
                      <Form.Label className="text_decoration">Permission Categories:</Form.Label>
                    </Form.Group>
                  </div>

                  <div className="col-sm-6">
                    <div className="radio_holder">
                      <Form.Check
                        inline
                        type="checkbox"
                        label="Dashboard Access"
                        name="sampleType"
                        value="Dashboard Access"
                        id="Dashboard Access"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="radio_holder flex-column">
                      <Form.Check
                        inline
                        type="checkbox"
                        label="Sample Management"
                        name="sampleType"
                        value="Sample Management"
                        id="Sample Management"
                      />
                      <small className="small_text">
                        {" "}
                        (Add / Edit / Delete / View)
                      </small>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="radio_holder">
                      <Form.Check
                        inline
                        type="checkbox"
                        label="Testing & Calibration"
                        name="sampleType"
                        value="Testing & Calibration"
                        id="Testing & Calibration"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="radio_holder">
                      <Form.Check
                        inline
                        type="checkbox"
                        label="Report Generation"
                        name="sampleType"
                        value="Report Generation"
                        id="Report Generation"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="radio_holder">
                      <Form.Check
                        inline
                        type="checkbox"
                        label="Invoice & Billing"
                        name="sampleType"
                        value="Invoice & Billing"
                        id="Invoice & Billing"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="radio_holder">
                      <Form.Check
                        inline
                        type="checkbox"
                        label="User Management"
                        name="sampleType"
                        value="User Management"
                        id="User Management"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="radio_holder">
                      <Form.Check
                        inline
                        type="checkbox"
                        label="Settings Access"
                        name="sampleType"
                        value="Settings Access"
                        id="Settings Access"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="offcanvas_footer_holder">
                {!success ? (
                  <>
                    <div className="btns_holder">
                      <Gray_Btn btnText={"Cancel"} />
                      <Black_Submit_Btn
                        btnText={"Submit"}
                        onClick={() => {
                          setSuccess(true);
                        }}
                      />
                    </div>
                    <Refresh_btn/>
                  </>
                ) : (
                  <Success_Toster
                    successText={"Role Added Successfully!"}
                  />
                )}
              </div>
            </div>
          </Form>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Add_Role;
